import { render, staticRenderFns } from "./TopBetsInfo.vue?vue&type=template&id=95c4cffc&scoped=true&"
var script = {}
import style0 from "./TopBetsInfo.vue?vue&type=style&index=0&id=95c4cffc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c4cffc",
  null
  
)

export default component.exports